export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkArea: "nav-link-area",
  linkAbout: "nav-link-about",
  linkGallery: "nav-link-gallery",
  linkContact: "nav-link-contact",
  callBtn: "nav-call-button",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  freeEstimateBtn: "hero-free-estimate-btn",
  callBtn: "hero-call-btn",
};

export const SERVICES = {
  interior: "service-interior",
  exterior: "service-exterior",
  pressure: "service-pressure-washing",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const FOOTER = {
  phone: "footer-phone",
  email: "footer-email",
  hours: "footer-hours",
};
